export const defaultMemberEmailCheckerFormFieldDisplayText = {
    label: 'Email address',
    requiredMessage: 'An email address is required.',
    formatMessage: 'Please enter your email address in format: yourname@example.com.'
};
//# sourceMappingURL=display-text.js.map